import { lazy } from 'react';

export const PlayerRemoveEmailSuppressionsForm = lazy(
  () => import('./PlayerRemoveEmailSuppressionsForm'),
);
